module.exports = __webpack_public_path__ + "img/icn_quotes.20fcce85.svg";